import { QueryDispatcher } from '@/modules/shared/domain/QueryDispatcher'

export class GetUserAllowedActionsQuery {
  constructor(private readonly dispatcher: QueryDispatcher) {}

  async execute(module: string): Promise<string[] | null> {
    try {
      const response = await this.dispatcher.dispatch('get.user.allowed.actions', { module })
      if (response === null) {
        return null
      }
      if (Array.isArray(response)) {
        return response
      }
      if (response && response.allowed_actions !== undefined) {
        return response.allowed_actions
      }
      return null
    } catch (error) {
      console.error('Error getting user allowed actions:', error)
      return null
    }
  }

  async isActionAllowed(module: string, actionCode: string): Promise<boolean> {
    const allowedActions = await this.execute(module)
    if (allowedActions === null) {
      return true
    }
    return allowedActions.includes(actionCode)
  }
}
